import { render, staticRenderFns } from "./delete_task.vue?vue&type=template&id=dc0c83c4&scoped=true"
import script from "./delete_task.vue?vue&type=script&lang=js"
export * from "./delete_task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c83c4",
  null
  
)

export default component.exports